import {useUser} from '@clerk/clerk-react'
import {createFileRoute, Navigate} from '@tanstack/react-router'
import {Loader2} from 'lucide-react'
import {useCurrentUser} from '@/hooks/users'

function AuthCallbackPage() {
	const {isLoaded: clerkLoaded, isSignedIn} = useUser()
	const {data: user, isError, error} = useCurrentUser()

	if (clerkLoaded && !isSignedIn) {
		return <Navigate to='/sign-in' />
	}

	if (user) {
		// Org-less developers live in the admin console — sending them to /today
		// would just bounce off the root's orgless guard (a visible double-hop).
		const orgless =
			user.role === 'DEVELOPER' && !user.organizationId && !user.impersonating
		return <Navigate to={orgless ? '/admin' : '/today'} />
	}

	if (isError) {
		return (
			<div className='flex flex-col justify-center items-center h-screen gap-4'>
				<div className='text-destructive text-lg font-medium'>
					Failed to set up your account
				</div>
				<div className='text-muted-foreground text-sm'>
					{error?.message || 'Please try signing in again.'}
				</div>
				<a
					href='/sign-in'
					className='px-4 py-2 bg-foreground text-background rounded-md hover:bg-foreground/90 transition-colors'
				>
					Go to Sign In
				</a>
			</div>
		)
	}

	return (
		<div className='flex flex-col justify-center items-center h-screen gap-4'>
			<Loader2 className='h-8 w-8 animate-spin text-muted-foreground' />
			<div className='text-muted-foreground text-lg'>
				Setting up your account...
			</div>
		</div>
	)
}

export const Route = createFileRoute('/auth/callback')({
	component: AuthCallbackPage,
})
